export default __webpack_public_path__ + "static/media/slide2.b6359669.png";